import { Routes, Route } from 'react-router-dom';

import './App.css';
import HomePage from './pages/home/HomePage';
import ComicDetailPage from './pages/comicDetail/ComicDetailPage';
import ArchivePage from './pages/archive/ArchivePage';
import AboutPage from './pages/AboutPage';


function App() {

  return (
    <div className="App font-opensans">
      <Routes>
        {["/", "/es"].map((path, index) => 
          <Route path={path} element={<HomePage />} key={index} />
        )}
        {["/archive", "/es/archive"].map((path, index) => 
          <Route path={path} element={<ArchivePage />} key={index} />
        )}
        {["/about", "/es/about"].map((path, index) => 
          <Route path={path} element={<AboutPage />} key={index} />
        )}
        {["/comic/:id", "/es/comic/:id"].map((path, index) => 
          <Route path={path} element={<ComicDetailPage />} key={index} />
        )}
      </Routes>
    </div>
  );
}

export default App;
